<template>
  <vs-row>
    <vs-col vs-w="12">
      <h3> Mantenedor de {{isMop ? 'Regiones' : 'Categorias' }} </h3>
      <h5 class="mb-5">
        Estas opciones activas aparecerán en los formularios de la aplicación.
      </h5>
    </vs-col>
    <vs-col vs-lg="12" id="listado-opciones" class="mt-5">
      <vs-row vs-type="flex" vs-align="space-around" vs-justify="space-around">
        <vs-col class="mt-3" vs-sm="12" vs-lg="6">
          <div class="add-new">
            <h4>{{isMop ? 'Regiones' : 'Categorias' }}</h4>
            <CheckPermission permission="ED031">
              <vs-button
                v-tooltip="'Agregar región'"
                color="primary"
                class="margin-right"
                @click="createMood = !createMood"
                type="border"
                icon="playlist_add"
              />
            </CheckPermission>
          </div>
          <vs-list class="bg-white mt-3 box-options">
            <div
              v-for="category in categoryRegions"
              class="wrap-list-item"
              :key="category.opcionId"
            >
              <ListItemOptionRegion
                :option="category"
                :type="'category'"
                :selectedCategory="selectedRegion
                && selectedRegion.opcionId === category.opcionId"/>
            </div>
          </vs-list>
        </vs-col>
      </vs-row>
    </vs-col>
    <b-modal
      :title="isMop ? 'Nueva región' : 'Nueva categoria'"
      v-model="createMood"
      no-close-on-backdrop
      centered
      hide-footer
    >
      <div>
        <input
          maxlength="10"
          class="input-option input-edit"
          placeholder="Abreviación"
          size="small"
          v-model="option.valor"
        />
      </div>
      <div>
        <input
          maxlength="100"
          class="input-option input-edit"
          placeholder="Nombre de opción"
          size="small"
          v-model="option.descripcion"
        />
      </div>
      <div class="d-flex justify-content-center">
        <vs-button
          color="primary"
          class="mt-3"
          type="border"
          icon="save"
          @click="saveOption()"
        >
          Guardar
        </vs-button>
      </div>
    </b-modal>
  </vs-row>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import ListItemOptionRegion from '../components/ListItemOptionRegion';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';

export default {
  name: 'MantenedorRegiones',
  components: { ListItemOptionRegion, CheckPermission },
  data() {
    return {
      createMood: false,
      option: {},
      isMop: null,
    };
  },
  created() {
    this.isMop = this.empresa.iut === '61202000-0';
  },
  watch: {
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#listado-opciones > .con-vs-loading');
        return;
      }
      this.$vs.loading({
        container: '#listado-opciones',
        scale: 0.6
      });
    },
    createMood() {
      this.option = {};
    }
  },
  computed: {
    ...mapGetters('Herramientas', [
      'loading',
      'categoryRegions',
      'selectedRegion'
    ]),
    ...mapGetters('Usuario', [
      'usuarioActual'
    ]),
    ...mapGetters('Empresas', [
      'empresa'
    ])
  },
  methods: {
    ...mapActions('Herramientas', [
      'listCategories',
      'listRegions',
      'clearRegions',
      'saveOptions'
    ]),
    async saveOption() {
      if ((this.option.valor && this.option.valor !== '')
        && (this.option.descripcion && this.option.descripcion !== '')) {
        const option = {
          valor: this.option.valor,
          descripcion: this.option.descripcion,
          configuradoPor: this.usuarioActual.id,
          referenciaId: this.empresa.id,
          parametroId: `tipos.regiones-ed.${this.option.valor}`,
          orden: this.categoryRegions.length + 1,
          nivel: 0,
          grupoId: 'tipos.regiones-ed',
          extra: '{}'
        };
        await this.saveOptions(option);

        if (Object.keys(this.selectedRegion).length) {
          await this.listRegions(this.selectedRegion);
        } else {
          await this.listCategories({
            grupoOpcion: 'tipos.regiones-ed',
            deshabilitado: 'si'
          });
        }
        this.createMood = false;
      } else {
        this.$bvToast.toast(
          'Tienes que colocar una abreviación / descripción',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
      }
    }
  },
  mounted() {
    this.clearRegions();
    this.listCategories({
      grupoOpcion: 'tipos.regiones-ed',
      deshabilitado: 'si'
    });
  }
};
</script>

<style lang="css" scoped>
  .box-options {
    height: 500px;
    overflow-y: scroll;
  }
  .add-new {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
  .input-option {
    margin-top: 10px;
    width: 100%;
    background: transparent;
  }
  .input-edit {
    border: 1px solid #66258324;
    padding: 4px 4px 6px 4px;
    border-radius: 5px;
  }
</style>
